"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _Auth = require("../providers/Auth");

var _Config = require("../providers/Config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function AuthorizedRoute(_ref) {
  var children = _ref.children;

  var _useConfig = (0, _Config.useConfig)(),
      appConfig = _useConfig.appConfig;

  var _ref2 = appConfig || {},
      authConfig = _ref2.auth;

  var _ref3 = authConfig || {},
      _ref3$signInURL = _ref3.signInURL,
      signInURL = _ref3$signInURL === void 0 ? "/signin" : _ref3$signInURL;

  var _useAuth = (0, _Auth.useAuth)(),
      auth = _useAuth.auth;

  var location = (0, _reactRouterDom.useLocation)();

  if (auth.isAuthenticated) {
    return children;
  } else {
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Navigate //to={`${signInURL}?from=${location.pathname}`}
    , {
      to: {
        pathname: signInURL,
        search: "from=" + location.pathname,
        state: {
          from: location
        }
      },
      replace: true
    });
  }
}

var _default = AuthorizedRoute;
exports["default"] = _default;
module.exports = exports.default;